import angular from 'angular';
import { videoPlayerComponent } from './videoPlayerComponent';
import { videoPlayerPlaylistComponent } from './playlist/videoPlayerPlaylistComponent';
import { VideoPlayerHtml5 } from './html5/VideoPlayerHtml5';
import { VideoPlayerVimeo } from './vimeo/VideoPlayerVimeo';
import { VideoPlayerYoutube } from './youtube/VideoPlayerYoutube';

angular
	.module('sh.videoPlayer', [])
	.component('shVideoPlayer', videoPlayerComponent())
	.component('shVideoPlayerPlaylist', videoPlayerPlaylistComponent())
	.constant('VideoPlayerHtml5', VideoPlayerHtml5)
	.constant('VideoPlayerVimeo', VideoPlayerVimeo)
	.constant('VideoPlayerYoutube', VideoPlayerYoutube);
